module.exports = __webpack_public_path__ + "img/14.faccd50a.png";